import type { z } from "zod";
import {
  OpsDocOwnerResponseSchema,
  OpsDocOwnerUpdateSchema,
  OpsDocOwnersResponseSchema,
  OpsDocSpaceAccessResponseSchema,
  OpsDocSpaceAccessUpdateSchema,
  OpsDocVerificationUpdateSchema,
  OpsDocImageSchema,
  OpsDocReviewsResponseSchema,
  type OpsDocSpaceAccessUpdate,
  type OpsDocVerificationUpdate,
} from "../../shared/operations-docs-maintenance";
import { OpsDocPageResponseSchema } from "../../shared/operations-docs-schemas";
import { parseResponse } from "../api/client-core";
const root = "/api/ops/docs";
export async function getDocReviews() {
  return parseResponse(
    await fetch(`${root}/reviews`, { credentials: "same-origin" }),
    OpsDocReviewsResponseSchema,
  );
}
const json = (body: unknown): RequestInit => ({
  method: "PUT",
  credentials: "same-origin",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(body),
});
export async function getDocSpaceAccess(spaceId: string) {
  return parseResponse(
    await fetch(`${root}/spaces/${encodeURIComponent(spaceId)}/access`, {
      credentials: "same-origin",
    }),
    OpsDocSpaceAccessResponseSchema,
  );
}
export async function updateDocSpaceAccess(spaceId: string, input: OpsDocSpaceAccessUpdate) {
  return parseResponse(
    await fetch(
      `${root}/spaces/${encodeURIComponent(spaceId)}/access`,
      json(OpsDocSpaceAccessUpdateSchema.parse(input)),
    ),
    OpsDocSpaceAccessResponseSchema,
  );
}
export async function getDocOwners(pageId: string) {
  return parseResponse(
    await fetch(`${root}/pages/${encodeURIComponent(pageId)}/owners`, {
      credentials: "same-origin",
    }),
    OpsDocOwnersResponseSchema,
  );
}
export async function updateDocOwner(
  pageId: string,
  input: z.infer<typeof OpsDocOwnerUpdateSchema>,
) {
  return parseResponse(
    await fetch(
      `${root}/pages/${encodeURIComponent(pageId)}/owner`,
      json(OpsDocOwnerUpdateSchema.parse(input)),
    ),
    OpsDocOwnerResponseSchema,
  );
}
export async function updateDocVerification(pageId: string, input: OpsDocVerificationUpdate) {
  return parseResponse(
    await fetch(
      `${root}/pages/${encodeURIComponent(pageId)}/verification`,
      json(OpsDocVerificationUpdateSchema.parse(input)),
    ),
    OpsDocPageResponseSchema,
  );
}
export async function uploadDocImage(pageId: string, file: File, signal: AbortSignal) {
  const response = await parseResponse(
    await fetch(`${root}/pages/${encodeURIComponent(pageId)}/images`, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": file.type },
      body: file,
      signal,
    }),
    OpsDocImageSchema,
  );
  return response.url;
}
